import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogData } from './typeing';
import { CommonDialogComponent } from './common-dialog.component';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonDialogService {
  constructor(public dialog: MatDialog) {}

  /**
   * 開啟共用確認彈窗
   * @param code
   * @param option
   * @returns
   */
  async openCommonDialog(
    code: number,
    option?: {
      parameters?: CommonDialogData['parameters']; // 可以帶入參數顯示畫面
      isShowCancelButton?: boolean; // 是否要顯示取消按鈕
    }
  ): Promise<string> {
    const commonDialogData: CommonDialogData = {
      code,
      parameters: option?.parameters || {},
      isShowCancelButton: option?.isShowCancelButton || false,
    };

    const dialogRef = this.dialog.open(CommonDialogComponent, {
      width: '350px',
      minHeight: '20vh',
      data: commonDialogData,
    });

    const result = await firstValueFrom(dialogRef.afterClosed());

    console.log(result);

    return result;
  }
}
